import { NavLink, Outlet } from "react-router-dom";

const Activity = () => {
  return (
    <div>
      <nav
        style={{
          marginTop: "1rem",
          marginBottom: "1rem",
          marginLeft: "1rem",
          display: "flex",
          gap: "1rem",
        }}
      >
        {/* Use NavLink for active tab styling */}
        <NavLink
          to="/activity"
          end
          className={({ isActive }) =>
            isActive
              ? "whitespace-nowrap font-bold text-xl border-b-4 border-[#2394f6] text-[#2394f6]"
              : "whitespace-nowrap font-bold text-xl text-gray-500 hover:text-[#2394f6]"
          }
        >
          Login Activity
        </NavLink>
        <NavLink
          to="/activity/analytics"
          className={({ isActive }) =>
            isActive
              ? "whitespace-nowrap font-bold text-xl border-b-4 border-[#2394f6] text-[#2394f6]"
              : "whitespace-nowrap font-bold text-xl text-gray-500 hover:text-[#2394f6]"
          }
        >
          Login Analytics
        </NavLink>
        <NavLink
          to="/activity/overview"
          className={({ isActive }) =>
            isActive
              ? "whitespace-nowrap font-bold text-xl border-b-4 border-[#2394f6] text-[#2394f6]"
              : "whitespace-nowrap font-bold text-xl text-gray-500 hover:text-[#2394f6]"
          }
        >
          Apps Activity
        </NavLink>
      </nav>

      {/* Render child routes here */}
      <Outlet />
    </div>
  );
};

export default Activity;
